export default __webpack_public_path__ + "static/media/blog_cardPic.b2b66a4f.png";